module.exports = __webpack_public_path__ + "static/media/united-kingdom.386cc387.svg";